<template>
  <div v-if="active" class="content-page">

    <div class="md-layout">
      <div class="md-layout-item md-size-100 mx-auto text-center">
        <h2 class="title">Estamos criando sua loja!</h2>
        <h5 class="description"><span class="mobile-hidden">Por favor não recarregue a janela. </span>Isso vai levar menos de um minuto...</h5>
      </div>
    </div>    

    <div class="md-layout">
      <div class="md-layout-item md-small-size-100 md-xsmall-size-100 md-medium-size-100 md-size-100">
        
        <md-card class="info-card">
          <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
              <md-icon>support</md-icon>
            </div>
            <h4 class="title">Mensagem do CEO</h4>
          </md-card-header>
          <md-card-content>            
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-xsmall-size-100 md-medium-size-50 md-size-50">
                <p>Enquanto espera sua loja ficar pronta, aproveite e <b>assista ao vídeo abaixo</b></p>
                <iframe class="wellcome-video" width="100%" height="480" src="https://www.youtube.com/embed/yNCCjqV8WhY?autoplay=1" title="Seja bem vindo à iSET!" frameborder="0" scrolling="no" allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </div>
              <div class="md-layout-item md-small-size-100 md-xsmall-size-100 md-medium-size-50 md-size-50">                
                <p>Faça nosso <b>TREINAMENTO GRATUITO</b> e descubra todo potencial da iSET para sua loja virtual.</p>
                <a :href="supportPanel.trainingLink" target="_blank"><img src="/img/banner-onboarding.png"/></a>
                <br/><br/>
              </div>
            </div>
          </md-card-content>
          <md-card-actions>
            <a :href="supportPanel.trainingLink" target="_blank"><md-button class="md-info slim-button">Conheça o Treinamento</md-button></a>
          </md-card-actions>
        </md-card>

      </div>
    </div>

    <!-- <div class="md-layout">
      <div class="md-layout-item md-medium-size-30 md-small-size-30 md-xsmall-size-60 md-size-30 mx-auto text-center">
        <processing/>
      </div>
    </div> -->

    <div class="md-layout">
      <div class="md-layout-item md-size-100 mx-auto text-center">
        <br/>
        <h5 class="description"><b>{{message}}</b></h5>
      </div>
    </div>


  </div>
</template>
<script>

// import Processing from "./Processing.vue";
import Swal from "sweetalert2";

export default {
  components: {
    // Processing
  },
  data() {
    return {
      session: this.$store.state.session,
      client: this.$store.state.client,
      business: this.$store.state.business,
      address: this.$store.state.address,
      domain: this.$store.state.domain,
      plan: this.$store.state.plan,
      order: this.$store.state.order,      
      hosting: this.$store.state.hosting,      
      ecommerce: this.$store.state.ecommerce,

      message: "Preparando plataforma de lançamento...",

      tips: [
        "Não esqueça de fazer os cursos gratuitos no Treinamento iSET!",
        "Com dúvidas? Converse com um dos nossos atendentes.",
        "Adquira ainda mais conhecimento sobre e-commerce através do blog da iSET!",
        "Acesse nossa base de conhecimento e o Treinamento iSET.",
        "Tenha acesso à vários tutoriais em nossa base de conhecimento.",
        "Sempre que precisar, converse com um dos nossos atendentes pelo chat online.",
      ],

      supportPanel: {        
        trainingLink: "https://ajuda.iset.com.br/pt-br/Introducao-ao-onboarding",
      },

      
      showTips: false,
    };
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },

  methods:{
    async start(){
      if (!this.checkRequired()) return;

      this.$store.commit('loader', [true, "Aguarde", "Ativando sua loja virtual..."]);
      this.$debug('PlanActivation => start');  
      
      let error = "";

      //IF NOT LOGGED IN
      if(!this.$store.state.client.id || !this.$store.state.client.loggedIn){
        //Register client & order
        if (await this.registerClient()){
          if (await this.registerOrder()){
            this.showTips = true;
            setTimeout(this.nextTip, 3000);
            error = await this.activateOrder();
            await this.createUser();
          
            this.showTips = false;
          } else error += "[ERR01: Pedido] ";
        } else error += " [ERR02: Cliente] ";
      } else {
        //Register order
        if (await this.registerOrder()){
          error = await this.activateOrder();
          await this.createUser();
        } else error += "[ERR03: Pedido] ";
      }

      if (error) 
        this.$functions.addLog(this.$route.name, 'activation', 'start', 'Erro durante ativação do pedido. SessionID #' + this.session.id +" | "+ error, 1);

      await this.checkUp();

      this.$store.commit('loader', [false]);
      this.finish();
    },

    async nextTip(){
      if (this.showTips){
        const index = Math.floor(Math.random() * this.tips.length);
        this.message = this.tips[index];
        setTimeout(this.nextTip, 3000);
      }
    },

    checkRequired(){
      //IF NOT LOGGED IN
      if(!this.$store.state.client.id || !this.$store.state.client.loggedIn){
        if (!this.$store.state.password){
          this.$functions.addLog(this.$route.name, 'activation', 'checkRequired', 'Senha ausente', 0);
          this.showError('Por algum motivo está faltando sua senha. Por favor, não recarregue a página durante o processo.', '/cadastro');
          return false;
        }

        if (!this.client.email || !this.client.firstName || !this.client.lastName){
          this.$functions.addLog(this.$route.name, 'activation', 'checkRequired', 'Cadastro ausente', 0);
          this.showError('Por algum motivo estão faltando dados cadastrais para concluir seu pedido.');
          return false;
        }
      }

      if (!this.domain.base || !this.domain.extension){
        this.$functions.addLog(this.$route.name, 'activation', 'checkRequired', 'Domínio ausente', 0);
        this.showError('Por algum motivo estão faltando dados de seu domínio para concluir seu pedido.', '/dominio');
        return false;
      }

      if (!this.domain.base || !this.domain.extension){
        this.$functions.addLog(this.$route.name, 'activation', 'checkRequired', 'Plano ausente', 0);
        this.showError('Por algum motivo estão faltando dados sobre o plano para concluir seu pedido.', '/plano');
        return false;
      }
      
      return true;
    },

    async registerClient(){
      this.$debug('PlanActivation => registerClient');
      this.message = "Registrando tripulante...";

      const params = {
        'gid': this.session.gid,
        'clientip': this.session.ipAddress,
        'email': this.client.email,
        'firstname': this.client.firstName,
        'lastname': this.client.lastName,
        'phonenumber': this.client.phone,
        'password2': this.$store.state.password,
        'companyname': this.business.company,
        'doctype': this.business.docType,
        'docnumber': this.business.docNumber,
        'postcode': this.address.CEP,
        'address1': this.address.street,
        'addressNumber': this.address.number,
        'addressComplement': this.address.complement,
        'address2': this.address.neighborhood,
        'city': this.address.city,
        'state': this.address.state,
      };

      return await this.$functions.post('registerClient', params, 'order.php').then((response) => {
        if (response.result == 'success'){
          this.$debug('Cliente cadastrado: ' + response.clientid);
          this.$store.commit('client', ['id', response.clientid]);
          return true;
        } else {
          this.$functions.showInfo("Desculpe =( aconteceu isso: " + response.message, 'danger');
          this.$functions.addLog(this.$route.name, 'activation', 'registerClient', 'Não foi possível concluir o cadastro: ' + JSON.stringify(response) +" | "+ JSON.stringify(params), 2);
          this.showError("Não foi possível concluir seu cadastro.");
          return false;
        }
      });
    },

    async registerOrder(){
      this.$debug('PlanActivation => registerOrder');
      this.message = "Abastecendo o foguete...";
      
      //VALIDATE PRICE OVERRIDE
      let priceOverride = 0;
      if (this.order.couponCycles.includes(this.order.cycle) &&
          this.order.couponPackages.includes(this.plan.id) && 
          this.order.coupon != '' && 
          this.order.couponValue >= 0 && 
          (this.order.couponType == 'Percentage' || this.order.couponType == 'Fixed Amount' || this.order.couponType == 'Price Override')){          
          priceOverride = 1;
      }

      const params = {
        'planId':           this.plan.id,
        'orderHosting':     this.order.hosting ? 1 : 0,
        'orderCycle':       this.order.cycle,
        'paymentMethod':    this.order.paymentMethod,
        'domainSubdomain':  this.domain.subdomain,
        'domainBase':       this.domain.base,
        'domainExtension':  this.domain.extension,
        'clientId':         this.client.id,
        'orderCoupon':      this.order.coupon,
        'orderAffid':       this.order.affid,
        'ipAddress':        this.session.ipAddress,
        'priceOverride':    priceOverride,
        'ecommercePrice':   this.ecommerce.price,
        'hostingPrice':     this.hosting.price,

        'cc-number':        this.order.creditcard.number,
        'cc-name':          this.order.creditcard.name,
        'cc-month':         this.order.creditcard.month,
        'cc-year':          this.order.creditcard.year,
        'cc-cvv':           this.order.creditcard.cvv,
      };

      this.$debug('PlanActivation => registerOrder');
      this.$debug(this.$store.state.ecommerce);

      return await this.$functions.post('registerOrder', params, 'order.php').then((response) => {
        if (response.result == 'success'){
          this.$debug('Pedido cadastrado: ' + response.orderid);
          this.$store.commit('order', ['id', response.orderid]);
          this.$store.commit('client', ['access_token', response.token.access_token]);
          this.$store.commit('invoice', ['id', response.invoiceid]);
          this.$store.commit('invoice', ['status', response.invoicestatus]);
          this.$store.commit('invoice', ['url', response.token.redirect_url]);
          
          if (this.order.hosting){
            const servicesids = response.serviceids.split(',');
            this.$store.commit('ecommerce', ['id', servicesids[0]]);
            this.$store.commit('hosting', ['id', servicesids[1]]);
          } else {
            this.$store.commit('ecommerce', ['id', response.serviceids]);
          }

          return true;
        } else {
          this.$functions.showInfo("Desculpe =( aconteceu isso: " + response.message, 'danger');          
          this.$functions.addLog(this.$route.name, 'activation', 'registerOrder', 'Não foi possível concluir o pedido: ' + JSON.stringify(response) +" | "+ JSON.stringify(params), 2);
          this.showError("Não foi possível concluir seu pedido.");
          return false;
        }
      });
    },

    async activateOrder(){
      this.$debug('PlanActivation => activateOrder');
      this.message = "Iniciando contagem regressiva...";

      const params = {'orderId': this.order.id};

      return await this.$functions.post('activateOrder', params, 'order.php').then((response) => {
        if (response.result == 'success'){
          this.$store.commit('order', ['status', 'active']);
        } else {
          this.$debug(response.message);
          return response.message;
        }
      });
    },

    async createUser(){
      this.$debug('PlanActivation => createUser');
      this.message = "Registrando tripulantes...";

      const params = {'serviceid':  this.ecommerce.id,
                      'domain':     this.domain.base + "." + this.$store.state.tempDomain,
                      'name':       this.client.firstName,
                      'email':      this.client.email, 
                      'cellphone':  this.client.phone, 
                      'password':   this.$store.state.password };

                      this.$debug('CREATE USER');
      let result = await this.$functions.post('createUser', params, 'order.php').then((response) => {
        if (response.result == 'success'){
          this.$store.commit('ecommerce', ['userCreated', true]);
          this.$store.commit('ecommerce', ['userToken', response.token]);
        } else {
          this.$debug(response.message);
          return response.message;
        }
      });

      return result;
    },

    async checkUp(){
      this.message = "Conferindo telemetria...";

      const params = {'orderId':        this.order.id,
                      'orderAffid':     this.order.affid,
                      'hostingId':      this.hosting.id,
                      'ecommerceId':    this.ecommerce.id,
                      'planId':         this.plan.id,
                      'planPrice':      this.order.cycle == 'annually' ? this.plan.annually : this.plan.monthly,
                      'coupon':         this.order.coupon,
                      'totalDays':      this.order.totalDays };

      return await this.$functions.post('orderCheckUp', params, 'order.php').then((response) => {
        if (response.result == 'success'){
          try{
            //ATUALIZAR STORE STATE
            this.$store.commit('order',     ['status',    response.order.status]);
            this.$store.commit('order',     ['total',     response.order.amount]);
            this.$store.commit('order',     ['totalDays', response.totalDays]);
            this.$store.commit('order',     ['nextDate',  response.nextDate]);
            this.$store.commit('hosting',   ['status',    response.hostingStatus]);
            this.$store.commit('ecommerce', ['status',    response.ecommerceStatus]);
            
            if (response.ecommerceStatus != 'Active'){
              this.$functions.addLog(this.$route.name, 'activation', 'checkUp', 'Erro ao ativar pedido #' + this.order.id, 1);
              //this.showWarning('Por algum motivo não foi possível ativar sua loja virtual automaticamente.');
              this.showWarning('Clique no botão PAINEL DE CONTROLE para acessar sua loja. #1');
              return false;
            }

            this.message = "Foguete lançado!";
            return true;
          }
          catch (error) {
            this.$functions.addLog(this.$route.name, 'activation', 'checkUp', 'Não foi possível conferir o pedido [#' + this.order.id + '] - ERROR: '+error+' - RESPONSE: '+JSON.stringify(response), 1);
            this.showWarning('Por algum motivo não foi possível conferir seu pedido.');
            this.debug('ERROR: ' + error);
            return false;
          }
        } else {
          this.$functions.addLog(this.$route.name, 'activation', 'checkUp', 'Não foi possível conferir o pedido [#' + this.order.id + '] - RESPONSE: '+JSON.stringify(response), 1);
          //this.showWarning('Por algum motivo não foi possível ativar sua loja virtual automaticamente.');
          this.showWarning('Clique no botão PAINEL DE CONTROLE para acessar sua loja. #2');
          return false;
        }
      });
      
    },

    showWarning(msg){
      this.message = "Houston, nós temos um pequeno problema...";
      this.$store.commit('order', ['warningMsg', msg]);
      this.$debug(msg);

      Swal.fire({
        title: "Desculpe =(",
        text: msg + " Por favor entre em contato com nosso atendimento via chat.",
        confirmButtonText: "Prosseguir",
        buttonsStyling: true
      }).then(result => {
        if (result.value) {
          this.finish();
        }
      });
    },

    showError(msg, route = '/'){
      this.message = "Houston, nós temos um grande problema...";
      this.$store.commit('order', ['errorMsg', msg]);
      this.$debug(msg);

      const actionMsg = route == '/' ? " Reinicie o processo ou peça ajuda ao nosso atendimento via chat." : " Por favor volte alguns passos para conferir.";
      const actionBtn = route == '/' ? " Reiniciar processo" : "Voltar";
      const actionClass = route == '/' ? "md-danger" : "md-warning";

      Swal.fire({
        title: "Desculpe =(",
        text: msg + actionMsg,
        confirmButtonClass: "md-button " + actionClass,
        confirmButtonText: actionBtn,
        buttonsStyling: true
      }).then(result => {
        if (result.value) {
          if (route == '/') this.$functions.resetAll(); 
          this.$router.push({ path: route });
        }
      });

    },

    finish(){
      this.$emit("on-finish");
    },
  },

}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/activation.scss";

.title{
  color:#333 !important;
  margin-bottom: 15px !important;
}

#freepik_stories-processing{
  max-width: 80px;
}

@media only screen and (max-width: 1280px) {
  .content-page{
    margin-bottom: 150px;
  }
  .description{
    font-size: 18px;    
  }
}

</style>